
import React, { forwardRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { GridActionsCellItem } from '@mui/x-data-grid';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { read } from 'Utils/Helpers/LocalStorage';
import { ConvertToAccess, ConvertToArray } from 'Utils/Helpers/AccessConvert';
import { editAccess, users_data } from 'http/components/UserService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetUsersData } from 'Utils/Helpers/HandleApiData';
import { enqueueSnackbar } from 'notistack';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UserAccess({ cell, row }) {
  const dispatch = useDispatch();
  const [access, setAccess] = useState(null);
  const [show, setShow] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const { current } = useSelector((state) => ({
    current: state.staff.current,
  }));
  const setShowDialog = () => {
    setShow(true);
    setAccess(ConvertToAccess(row.access));
  }
  useEffect(() => {
    if(access) {
      let all = [];
      access.map(i => {
        return i.details.map((j) => {
          return all.push(j.access);
        })
      })
      setSelectAll(all.reduce((a, b) => {
        if(a&&b) return true;
        else return false;
      }));
    }
  }, [access])
  const handleClose= () => {
    setShow(false);
  }

  const handleChange = (e) => {
    if(e.target.id !== 'select_all') {
      const _new = access.map(i => {
        if(i.id === e.target.id[0]) {
          i.details.map(j => {
            if(j.id === e.target.id) {
              j.access = e.target.checked;
            }
            return j;
          })
        }
        return i;
      })
      setAccess(_new);
    } else {
      const _new = access.map(i => {
          i.details.map(j => {
              j.access = e.target.checked;
            return j;
          })
        return i;
      })
      setAccess(_new);
    }
  }

  const onFinish = async () => {
    dispatch(HandleLoading(true));
    const response = await editAccess(row.id, ConvertToArray(access));
    if(response.status) {
      const response2 = await users_data();
      if(response2.status) {
          await dispatch(SetUsersData(response2.data))
          enqueueSnackbar('دسترسی کاربر با موفقیت ویرایش شد', {variant: 'success'});
          setShow(false);
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      dispatch(HandleLoading(false));
    }
  }

  function Title ({ name }) {
    return (
      <p>
        {name}
        {' : '}
      </p>
    )
  }

  function CheckBox ({ id, access, title }) {
    return (
      <FormControlLabel 
        key={`access_FCL_${title}`}
        control={<Checkbox 
          checked={access}
          id={id}
          onChange={handleChange}
        />}
        label={title}
      />
    )
  }

  return (
    <>
      <GridActionsCellItem
        icon={<icons.PersonWorkspace size={16}/>}
        label="Delete"
        onClick={setShowDialog}
        className={row.id === read('local') ? 'd-none' : ''}
        disabled={!current[3][2]}
        hidden={!current[3][2]}
      />
      {
        show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-appointment-edit"
        >
          <DialogTitle className=''>
            {`دسترسی‌های‌ ${row.name.substring(0, row.name.indexOf(" "))}`}
            <div className='close-btn' onClick={handleClose}>
              <icons.X/>
            </div>
          </DialogTitle>
          <DialogContent>
            {
              show && access &&
              <DialogContentText id="alert-dialog-slide-appointment-edit">
                <div className='access-body'>
                  {
                    access && <div className='select-all'>
                      <CheckBox
                        key={`access_CB_SELECT_ALL`}
                        id={'select_all'}
                        access={selectAll}
                        title={"انتخاب همه"}
                      />
                    </div>
                  }
                  {
                    access.map(items => {
                      return (
                        <>
                          <Title name={items.name} />
                          <div className='details'>
                            {
                              items.details.map(det => {
                                return (
                                  <CheckBox 
                                    key={`access_CB_${det.title}`}
                                    id={det.id}
                                    access={det.access}
                                    title={det.title}
                                  />
                                )
                              })
                            }
                          </div>
                        </>
                      )
                    })
                  }
                </div>
              </DialogContentText>
            }
          </DialogContent>
          <DialogActions>
            <CButton
              text={'‌ذخیره سطح دسترسی کاربر'}
              icon={<icons.Save2/>}
              onClick={onFinish}
            />
          </DialogActions>
        </Dialog>
      }
    </>
  );
}
